import { render, staticRenderFns } from "./StPage.vue?vue&type=template&id=5d8d5f14&"
import script from "./StPage.vue?vue&type=script&lang=js&"
export * from "./StPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports